export function createDateTimeString(date) {
    if (!date) return null;
    const date_1 = date.toLocaleDateString("hu").replace(/\s/g, "").replace(/\./g, '-').slice(0,-1);
    const date_2 = date.toLocaleTimeString("hu");

    return `${date_1} ${date_2}`;
}